// extracted by mini-css-extract-plugin
module.exports = {"root":"RoleSwitcher_root_1vBGs","label":"RoleSwitcher_label_RJ2LH"};